
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/itineraries",
      function () {
        return require("private-next-pages/itineraries.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/itineraries"])
      });
    }
  